module.exports = __webpack_public_path__ + "img/cashback.f8ad1a9c.png";